import React from 'react'
import MasterPage from './MasterPage'

function Contact() {
    return (
        <MasterPage>
            <div className="min-h-screen bg-white px-6 py-10 md:px-20">
                <div className="max-w-5xl mx-auto text-center">
                    <h1 className="text-4xl font-bold text-blue-700 mb-4">Contact Us</h1>
                    <p className="text-gray-600 text-lg mb-12">
                        We'd love to hear from you. Reach out to us via any of the methods below.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
                        {/* Address */}
                        <div className="bg-blue-50 rounded-xl shadow p-6">
                            <h2 className="text-xl font-semibold text-blue-600 mb-2">Our Offices</h2>
                            <div className="text-gray-700 text-sm space-y-3">
                                <div>
                                    <p className="font-medium">Lucknow Office:</p>
                                    <p>Dixit Plaza, Nahar Road, Jankipuram Extension,<br />Lucknow 226201, India</p>
                                </div>
                                <div>
                                    <p className="font-medium">Mau Office:</p>
                                    <p>Anjum Manzil, 8, Bhojamaman Doyam,<br />Maunath Bhanjan, Mau 275101, India</p>
                                </div>
                            </div>
                        </div>

                        {/* Email */}
                        <div className="bg-blue-50 rounded-xl shadow p-6">
                            <h2 className="text-xl font-semibold text-blue-600 mb-2">Email Us</h2>
                            <p className="text-sm text-gray-700">
                                Send your queries or business inquiries to:
                            </p>
                            <a
                                href="mailto:info@doctora.live"
                                className="block mt-3 text-blue-700 font-medium underline"
                            >
                                info@doctora.live
                            </a>
                        </div>

                        {/* Phone */}
                        <div className="bg-blue-50 rounded-xl shadow p-6">
                            <h2 className="text-xl font-semibold text-blue-600 mb-2">Call Us</h2>
                            <p className="text-sm text-gray-700">Mon–Sat, 10 AM – 6 PM</p>
                            <p className="mt-3 text-blue-700 font-bold text-lg">+91 9559952123</p>
                        </div>
                    </div>

                    <p className="text-sm text-gray-500 mt-16">
                        We're here to support you every step of the way. 💙
                    </p>
                </div>
            </div>
        </MasterPage>
    )
}

export default Contact